import styled from 'styled-components';

export const Truncate = styled.div`
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
`;
